import React from "react";
import { PRIMARY_COLOR } from "./featureConfig";

const FeaturePagination = ({ page, totalPages, total, onChange, pageSize = 10 }) => {
  if (totalPages <= 1) return null;

  const handlePageChange = (newPage) => {
    if (onChange) {
      // MUI Pagination onChange signature: (event, value)
      onChange(null, newPage);
    }
  };

  const startItem = ((page - 1) * pageSize) + 1;
  const endItem = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between mt-6 px-4">
      <span className="text-sm text-gray-600">
        Showing {startItem} to {endItem} of {total} results
      </span>
      <div className="flex items-center space-x-2">
        <button
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
          className="px-3 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Previous
        </button>
        <div className="flex items-center space-x-1">
          {[...Array(Math.min(5, totalPages))].map((_, i) => {
            let pageNum;
            if (totalPages <= 5) {
              pageNum = i + 1;
            } else if (page <= 3) {
              pageNum = i + 1;
            } else if (page >= totalPages - 2) {
              pageNum = totalPages - 4 + i;
            } else {
              pageNum = page - 2 + i;
            }
            
            return (
              <button
                key={i}
                onClick={() => handlePageChange(pageNum)}
                className={`px-3 py-1 text-sm font-medium rounded-md ${
                  page === pageNum
                    ? `bg-[${PRIMARY_COLOR}] text-white`
                    : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
                }`}
                style={page === pageNum ? { backgroundColor: PRIMARY_COLOR, color: '#fff' } : {}}
              >
                {pageNum}
              </button>
            );
          })}
        </div>
        <button
          onClick={() => handlePageChange(page + 1)}
          disabled={page === totalPages}
          className="px-3 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default FeaturePagination;



